if (!customElements.get('size-finder')) {
  class SizeFinder extends HTMLElement {
    constructor() {
      super();
      const dataScript = this.querySelector('[data-size-finder-data]');
      this.rows = dataScript ? JSON.parse(dataScript.textContent) : [];
      this.bustSelect = this.querySelector('[data-size-finder-bust]');
      this.waistSelect = this.querySelector('[data-size-finder-waist]');
      this.lengthSelect = this.querySelector('[data-size-finder-length]');
      this.bustMessage = this.querySelector('[data-size-finder-bust-message]');
      this.waistMessage = this.querySelector('[data-size-finder-waist-message]');
      this.lengthMessage = this.querySelector('[data-size-finder-length-message]');
      this.result = this.querySelector('[data-size-finder-result]');
      this.update = this.update.bind(this);
      if (this.bustSelect) this.bustSelect.addEventListener('change', this.update);
      if (this.waistSelect) this.waistSelect.addEventListener('change', this.update);
      if (this.lengthSelect) this.lengthSelect.addEventListener('change', this.update);

      this.categoryLabel = this.dataset.categoryLabel || '';
      if (this.categoryLabel) {
        this.categoryScope = this.closest('.sizing-chart__modal') || document;
        this.syncCategoryVisibility = this.syncCategoryVisibility.bind(this);
        this.categoryScope.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"][name^="SizingChartTab-"]')) {
            this.syncCategoryVisibility();
          }
        });
        this.syncCategoryVisibility();
      }
    }

    syncCategoryVisibility() {
      const checkedRadio = this.categoryScope.querySelector(
        'input[type="radio"][name^="SizingChartTab-"]:checked'
      );
      if (!checkedRadio) return;
      const label = this.categoryScope.querySelector(`label[for="${checkedRadio.id}"]`);
      const activeCategory = label ? label.textContent.trim() : '';
      this.hidden = activeCategory !== this.categoryLabel;
    }

    update() {
      const bust = this.bustSelect ? this.bustSelect.value : '';
      const waist = this.waistSelect ? this.waistSelect.value : '';
      const length = this.lengthSelect ? this.lengthSelect.value : '';
      if (this.bustMessage) this.bustMessage.textContent = bust;
      if (this.waistMessage) this.waistMessage.textContent = waist;
      if (this.lengthMessage) this.lengthMessage.textContent = length;
      if (!this.result) return;
      if (!bust || !length || (this.waistSelect && !waist)) {
        this.result.textContent = '...';
        return;
      }
      // Match on bust alone: bust/waist/length come from independent dropdowns, so a
      // combination that doesn't correspond to any real garment row is easy to pick
      // (e.g. one size's chest with another size's length). Bust is the primary sizing
      // signal (see the disclaimer text: chest measurement takes priority when
      // measurements point to different sizes), so recommend by bust and let the
      // other dropdowns stay purely informational in the "you selected" message.
      const match = this.rows.find((row) => row.bust === bust);
      this.result.textContent = match ? match.size : '...';
    }
  }

  customElements.define('size-finder', SizeFinder);
}
